import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Button, Modal, message, Spin, Pagination, Empty } from 'antd';
import { regRichText } from '@utils/utils';
import NoticeDetails from './components/NoticeDetails';
import NoticeAddDrawer from './components/NoticeAddDrawer';
import { noticesListApi, delNoticesInfoApi } from '@services/MedProject';
import './index.less';
import PageHeader from '@components/PageHeader/PageHeader';
import { useProjectContext } from '@/contexts/ProjectContext';
import { WORKSPACE_PARENT_PATH, WORKSPACE_ROUTE_BASE } from '@/layouts/workspaceConfig';

export default function RelatedProjectList() {
    const params = useParams();
    const { id: projectContextId, name: projectName } = useProjectContext();

    const medProjectId = (params?.projectId ?? params?.id) || 0; // 项目 ID

    useEffect(() => {
        document.title = '通知管理-医项目';
    }, []);

    // 分页
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [total, setTotal] = useState(0);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    // 页码改变
    const onChangePage = (a, b) => {
        setPage(a);
        setPageSize(b);
    };

    // 新增/详情
    const [currentId, setCurrentId] = useState(undefined);
    const [detailsOpen, setDetailsOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    // 通知详情
    const details = item => {
        setCurrentId(item);
        setDetailsOpen(true);
    };

    // 删除
    const del = delId => {
        Modal.confirm({
            title: '提示',
            icon: <i className="bi bi-exclamation-circle"></i>,
            content: `删除后，用户端也会同时删除，是否确认删除？`,
            centered: true,
            onOk: async () => {
                const res = await delNoticesInfoApi({ id: delId });
                if (res.status_code === 200) {
                    message.success('删除成功');
                    getNotices();
                }
            },
        });
    };

    // 发布通知弹窗
    const release = () => {
        setIsModalOpen(true);
    };

    const getNotices = async () => {
        setLoading(true);
        const reqParams = {
            medProjectId,
            page,
            pageSize,
        };
        const res = await noticesListApi(reqParams);
        setLoading(false);
        if (res.status_code === 200 && res.data) {
            const noticeData = res.data.list || [];
            if (noticeData.length > 0) {
                for (const item of noticeData) {
                    item.content = regRichText(item.content);
                }
            }
            setData(noticeData);
            setTotal(res.data.totalCount);
        }
    };

    useEffect(() => {
        if (!!medProjectId) {
            getNotices();
        }
    }, [page, pageSize, medProjectId]);

    return (
        <>
            <PageHeader title="通知管理" breadcrumb={[{ label: '医项目', path: WORKSPACE_PARENT_PATH }, { label: projectName, path: `${WORKSPACE_ROUTE_BASE}/${projectContextId}` }, '通知管理']} />

            <div className="page-route-body">
                <div className="main-tools">
                    <Button type="primary" onClick={() => release()}>
                        发布通知
                    </Button>
                </div>

                <div className="main-notices">
                    <Spin spinning={loading}>
                        {data.length === 0 ? (
                            !loading && <Empty description="暂无通知" />
                        ) : (
                            <>
                                <div className="notice-list">
                                    {data.map(item => (
                                        <div key={item.id} className="notice-list-item">
                                            <div className="notice-list-item-head">
                                                <div className="notice-list-item-title">{item.title}</div>
                                                <div className="operationArea">
                                                    <Button type="link" className="operateButton" onClick={() => details(item.id)}>
                                                        详情
                                                    </Button>
                                                    <Button type="link" className="operateButton" onClick={() => del(item.id)}>
                                                        删除
                                                    </Button>
                                                </div>
                                            </div>
                                            <div className="notice-content">
                                                <span>{item.content}</span>
                                            </div>
                                            <div className="notice-list-item-actions">
                                                <div>
                                                    <i className="bi bi-star"></i>
                                                    <span> {item.createdAt}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <Pagination className="notice-list-pagination" total={total} showTotal={t => `共${t}条`} current={page} pageSize={pageSize} onChange={onChangePage} showQuickJumper showSizeChanger />
                            </>
                        )}
                    </Spin>
                </div>

                <NoticeAddDrawer isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} getNotices={getNotices} />
                <NoticeDetails detailsOpen={detailsOpen} setDetailsOpen={setDetailsOpen} currentId={currentId} />
            </div>
        </>
    );
}
